import type { ReactNode } from 'react';
import { SampleAccentHeading } from './SampleAccentHeading';

export type SampleFormSectionTitleProps = {
  icon: string;
  children: ReactNode;
  /** 右側（例: 使用履歴の追加ボタン） */
  trailing?: ReactNode;
  className?: string;
};

/** サンプル登録・編集フォームのセクション見出し */
export function SampleFormSectionTitle({
  icon,
  children,
  trailing,
  className,
}: SampleFormSectionTitleProps) {
  return (
    <SampleAccentHeading
      icon={icon}
      trailing={trailing}
      className={`sample-form-section-heading${className ? ` ${className}` : ''}`.trim()}
      titleAs="h5"
      contentSepAfter
    >
      {children}
    </SampleAccentHeading>
  );
}
